<template>
    <div class="grid-table">
        <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>

        <div class="clearfix float_r filter-block-header">
            <per-pager
                v-bind:per-page="pagination.perPage"
                :page-query-name="pageQuery"
                :query-name="perPageQuery"
                v-on:update="load"
            />
        </div>
        <table class="table table-striped table-hover datatables" :class="{'table-fixed-header': fixedHeader === true}" cellspacing="0" width="100%">
            <thead>
            <tr ref="header">
                <slot name="header">
                    <th v-for="(cell, index) in header" v-bind:key="index">
                        <router-link
                            :to="getSortRoute(cell.sort)"
                            v-if="cell.sort"
                            :class="{
                                asc: sort === cell.sort,
                                desc: sort === ('-' + cell.sort),
                            }"
                        >
                            {{cell.title}}
                        </router-link>
                        <span v-else>{{cell.title}}</span>
                    </th>
                </slot>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in rows" v-bind:key="index">
                <slot name="row" v-bind:row="row"></slot>
            </tr>
            <tr v-if="rows.length === 0" class="grid-empty-row">
                <slot name="empty">
                    <td :colspan="getHeaderRows()">Нет данных</td>
                </slot>
            </tr>
            <tr v-if="isError === true" class="grid-empty-row">
                <slot name="error">
                    <td :colspan="getHeaderRows()">Ошибка загрузки</td>
                </slot>
            </tr>
            </tbody>
        </table>
        <paginator
            v-bind="pagination"
            :query-name="pageQuery"
            v-on:update="load"
        />
    </div>
</template>

<script>

    import Helper from "../../../classes/Helper";

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            PerPager: () => import('./PerPager'),
            Paginator: () => import('./Paginator'),
        },

        props: {
            header: {
                type: Array,
                default: function() {
                    return [];
                }
            },
            storeName: {
                type: String,
                default: '',
            },
            pageQuery: {
                type: String,
                default: 'page',
            },
            perPageQuery: {
                type: String,
                default: 'per-page',
            },
            sortQuery: {
                type: String,
                default: 'sort',
            },
          fixedHeader: {
            type: Boolean,
            default: false,
          },
            loader: {
                type: Function,
                default: function() {
                    return function() {
                        return {data:[], headers: {}};
                    }
                },
            },
            extraFields: {
                type: Array,
                default: function() {
                    return [];
                }
            },
            filter: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            defaultSort: undefined,
        },

        data() {
            return {
                isLoading: false,
                isError: false,
                pagination: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 0,
                    totalCount: 0,
                },
                rows: [],
                sort: this.defaultSort,
            };
        },

        beforeMount() {
            this.load();
        },

        watch: {
            'pagination.perPage': function(value) {
                if (this.storeName === '') {
                    return;
                }
                this.setDefaultPerPage(value);
            },
            '$route.query':  function(newValue, oldValue) {
                if (newValue[this.sortQuery] !== oldValue[this.sortQuery]) {
                    this.load();
                }
            },
        },
        methods: {
            async load() {
                this.isLoading = true;

                let page = this.$route.query.page ? this.$route.query.page : 1;
                let perPage = this.$route.query[this.perPageQuery] ? this.$route.query[this.perPageQuery] : this.getDefaultPerPage();
                this.sort = this.$route.query[this.sortQuery] ? this.$route.query[this.sortQuery] : this.defaultSort;

                let response;
                try {
                    response = await this.loader(this.filter, page, this.sort, perPage, this.extraFields);
                    this.isError = false;
                } catch (e) {
                    this.isError = true;
                    this.isLoading = false;
                    return;
                }

                this.rows = response.data;
                this.pagination.currentPage = Number(response.headers['x-pagination-current-page']);
                this.pagination.pageCount = Number(response.headers['x-pagination-page-count']);
                this.pagination.perPage = Number(response.headers['x-pagination-per-page']);
                this.pagination.totalCount = Number(response.headers['x-pagination-total-count']);

                this.isLoading = false;
            },

            getDefaultPerPage() {
                if (this.storeName && this.$store.state.template.perPages[this.storeName]) {
                    return this.$store.state.template.perPages[this.storeName];
                }
                return 25;
            },
            setDefaultPerPage(value) {
                this.$store.commit('template/setPerPage', {name: this.storeName, value: value})
            },
            getHeaderRows() {
                return this.$refs.header ? this.$refs.header.childElementCount : 1;
            },

            getRoute() {
                const route = {
                    name: this.$route.name,
                    params: this.$route.params,
                    query: this.$route.query,
                };

                return Helper.copyObject(route);
            },
            getSortRoute(sort) {
                const to = this.getRoute();
                if (this.sort === sort) {
                    to.query[this.sortQuery] = '-' + sort;
                } else {
                    to.query[this.sortQuery] = sort;
                }

                return to;
            },

            setSort(sort) {
                this.$router.push(this.getSortRoute(sort));
                this.load();
            },
        },
    }
</script>
